import { z } from "zod";

export const generateNewHireFileUrlRequestSchema = z.object({
  record_id: z.string(),
});

export type IGenerateNewHireFileUrlRequest = z.infer<
  typeof generateNewHireFileUrlRequestSchema
>;

export const generateNewHireFileUrlResponseSchema = z.object({
  url: z.string(),
  fileExtension: z.string(),
});

export type IGenerateNewHireFileUrlResponse = z.infer<
  typeof generateNewHireFileUrlResponseSchema
>;

export const generateNewHireFileUrlApiResponseSchema = z.object({
  data: generateNewHireFileUrlResponseSchema,
  success: z.boolean(),
  testMode: z.boolean().optional(),
});

export type IGenerateNewHireFileUrlApiResponse = z.infer<
  typeof generateNewHireFileUrlApiResponseSchema
>;
